import debounce from 'lodash.debounce';

type ReturnType = {
  addListener: () => void;
  removeListener: () => void;
};

export const listenForViewportChange = (callback: () => void): ReturnType => {
  const viewport =
    (window.visualViewport as VisualViewport | undefined) ?? window;
  const getBoundsDebounced = debounce(callback, 200);

  const addListener = (): void => {
    viewport.addEventListener('resize', getBoundsDebounced);
  };

  const removeListener = (): void => {
    viewport.removeEventListener('resize', getBoundsDebounced);
  };

  return {
    addListener,
    removeListener,
  };
};
